import React from 'react';
import { Star, Shield, Lock, CreditCard } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'Antes todos los días me sentía pesada y con el vientre inflamado sin importar qué comiera. Con este sistema entendí que no era la cantidad, sino el momento justo. ¡Hoy me siento liviana y mi pareja no deja de notar mi nueva energía!',
    name: 'Laura',
    age: '43 años',
    photo: 'https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=100&h=100&fit=crop&crop=face'
  }, {
    text: 'Pensé que a mi edad el metabolismo simplemente se detenía. Este protocolo me enseñó que podía comer postres de chocolate y seguir bajando cm de cintura. Es el único plan que realmente pude sostener porque no paso hambre.',
    name: 'Sonia',
    age: '52 años',
    photo: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=100&h=100&fit=crop&crop=face'
  }, {
    text: 'Mi mayor problema eran los antojos de la tarde y la falta de tiempo para cocinar. Los smoothies y la logística de 30 minutos me cambiaron la vida. Ya no me peleo con mi cuerpo, ahora trabajo a favor de él.',
    name: 'Marta',
    age: '45 años',
    photo: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=100&h=100&fit=crop&crop=face'
  }, {
    text: 'He recuperado la confianza en mí misma. Ver que mi ropa me queda mejor en solo 2 semanas fue el impulso que necesitaba. Mi pareja me preguntó qué estaba haciendo diferente porque mi piel y mi humor han mejorado muchísimo.',
    name: 'Carla',
    age: '48 años',
    photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop&crop=face'
  }, {
    text: 'Lo que más me gusta es que es un protocolo científico pero fácil de seguir. No cuento calorías ni peso la comida. Es libertad pura y resultados reales que se ven en el espejo todos los días.',
    name: 'Elena',
    age: '41 años',
    photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face'
  }];
  return <section className="py-10 bg-cream" data-id="element-470">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-471">
        <div className="max-w-5xl mx-auto" data-id="element-472">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-sage text-center mb-8 leading-tight" data-id="element-473">
            Lo que dicen quienes ya usan el Protocolo Vientre Plano 40+
          </h2>

          <div className="grid md:grid-cols-2 gap-5 mb-10" data-id="element-474">
            {testimonials.map((t, idx) => <div key={idx} className="bg-white rounded-2xl p-6 shadow-md border border-sage/5" data-id="element-475">
                <div className="flex items-center gap-3 mb-3" data-id="element-476">
                  <img src={t.photo} alt={t.name} className="w-11 h-11 rounded-full object-cover flex-shrink-0 border-2 border-gold/30" data-id="element-477" />
                  <div className="flex gap-0.5" data-id="element-478">
                    {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-gold fill-gold" data-id="element-479" />)}
                  </div>
                </div>

                <p className="text-sage/80 leading-relaxed mb-4 text-[15px]" data-id="element-480">
                  "{t.text}"
                </p>

                <p className="font-bold text-sage text-sm" data-id="element-481">
                  {t.name}{' '}
                  <span className="font-normal text-sage/60" data-id="element-482">({t.age})</span>
                </p>
              </div>)}
          </div>

          {/* Guarantee */}
          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border border-sage/10 flex items-start gap-5 max-w-2xl mx-auto" data-id="element-483">
            <Shield className="w-10 h-10 text-gold flex-shrink-0 mt-1" data-id="element-484" />
            <div data-id="element-485">
              <h4 className="font-serif font-bold text-sage text-lg mb-2" data-id="element-486">
                Garantía "Vientre Liviano"
              </h4>
              <p className="text-sage/70 leading-relaxed" data-id="element-487">
                7 días de prueba. Si no notás la diferencia, te devolvemos el
                100% de tu dinero. Sin preguntas.
              </p>
            </div>
          </div>

          {/* Trust icons */}
          <div className="flex items-center justify-center gap-8 mt-6 text-sage/40 text-sm" data-id="element-488">
            <div className="flex items-center gap-2" data-id="element-489">
              <Lock className="w-4 h-4" data-id="element-490" /> Pago Seguro
            </div>
            <div className="flex items-center gap-2" data-id="element-491">
              <CreditCard className="w-4 h-4" data-id="element-492" /> Todas las tarjetas
            </div>
          </div>
        </div>
      </div>
    </section>;
}